/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ITotalDiscounts,
  ITotalDiscountsInterface,
} from "../ITotalDiscounts";

const _abi = [
  {
    inputs: [],
    name: "totalDiscounts",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ITotalDiscounts__factory {
  static readonly abi = _abi;
  static createInterface(): ITotalDiscountsInterface {
    return new utils.Interface(_abi) as ITotalDiscountsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ITotalDiscounts {
    return new Contract(address, _abi, signerOrProvider) as ITotalDiscounts;
  }
}
